import gql from 'graphql-tag';

export const CommunitySummaryResultsPartial = gql`
  subscription communitySummaryResultsPartial($jobId: String!, $communityUuid: String!) {
    simulationAreaResultsPartial(jobId: $jobId, areaUUID: $communityUuid, timeResolutionHrs: 2) {
      priceEnergyAreaBalance
      cumulativeNetEnergyFlow
    }
  }
`;
